{
  "primer": {
    "eyebrow": "নামাজের সময় ও কিবলা",
    "headline": "নামাজের সময় ও কিবলার জন্য Rhemn-এর আপনার অবস্থান প্রয়োজন।",
    "body": "আমরা এটি শুধু আপনার নামাজের সময়, কিবলার দিক ও স্থানীয় আবহাওয়ার জন্য ব্যবহার করি — আর কিছুই নয়।",
    "cta": "চালিয়ে যান",
    "skip": "এখন নয়",
    "skip_body": "নামাজের সময় ও কিবলা বন্ধ থাকবে।"
  }
}
